import { useEffect, useState } from 'react'

const PAGE_SIZE = 20

const useIdeaChallengeModal = ({
  isHackathonEnable,
  listInnovateChallenge,
  getInnovateChallengeFilterListFn,
  getActiveChallenges,
}) => {
  const [showIdeaChallengeModal, setShowIdeaChallengeModal] = useState(false)
  const [offset, setOffset] = useState(0)
  const [challengeListData, setChallengeListData] = useState([])

  useEffect(() => {
    if (!showIdeaChallengeModal) return

    if (offset === 0) {
      setChallengeListData(listInnovateChallenge || [])
    } else {
      setChallengeListData((prev) => [...prev, ...(listInnovateChallenge || [])])
    }
  }, [listInnovateChallenge, offset, showIdeaChallengeModal])

  const openIdeaModal = () => {
    setShowIdeaChallengeModal(true)
    setChallengeListData([])
    setOffset(0)

    if (isHackathonEnable) {
      getInnovateChallengeFilterListFn('ACTIVE', 0, PAGE_SIZE, isHackathonEnable)
    } else {
      getActiveChallenges('ACTIVE', 0, 11, isHackathonEnable)
    }
  }

  const closeIdeaModal = () => {
    setShowIdeaChallengeModal(false)
    setChallengeListData([])
    setOffset(0)
  }

  const loadMoreChallenges = () => {
    if (!isHackathonEnable) return

    const nextOffset = offset + PAGE_SIZE
    setOffset(nextOffset)

    getInnovateChallengeFilterListFn(
      'ACTIVE',
      nextOffset,
      PAGE_SIZE,
      isHackathonEnable
    )
  }

  return {
    showIdeaChallengeModal,
    challengeListData,
    openIdeaModal,
    closeIdeaModal,
    loadMoreChallenges,
  }
}

export default useIdeaChallengeModal